import React from "react";

// ✅ Add this (copied from chart)
const transformData = (data) => {
    const result = {};

    data.forEach(item => {
        const date = new Date(item.month);

        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];

        const month =
            `${monthNames[date.getMonth()]} ${date.getFullYear()}`;

        if (!result[month]) {
            result[month] = { month, total: 0 };
        }

        const value = Number(item.count);

        result[month][item.Department] = value;
        result[month].total += value;
    });

    return Object.values(result);
};

const PlacedTable = ({ data, onViewDetails }) => {
    const tableData = transformData(data);

    // ✅ Sorted departments (same as chart)
    const departments = Object.entries(
        data.reduce((acc, item) => {
            acc[item.Department] = (acc[item.Department] || 0) + Number(item.count);
            return acc;
        }, {})
    )
        .sort((a, b) => b[1] - a[1])
        .map(([dep]) => dep);

    return (
        <div>
            <h3>Placed Students Table</h3>

            <table border="1" cellPadding="8" style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                    <tr>
                        <th>Month</th>
                        {departments.map(dep => (
                            <th key={dep}>{dep}</th>
                        ))}
                        <th>Total</th>
                    </tr>
                </thead>

                <tbody>
                    {tableData.map((row, index) => (
                        <tr key={index}>
                            <td>
                                <button
                                    className="view-details-link"
                                    onClick={() =>
                                        onViewDetails(row.month)
                                    }
                                >
                                    {row.month}
                                </button>
                            </td>
                            {departments.map(dep => (
                                <td key={dep}>
                                    {row[dep] || 0}
                                </td>
                            ))}

                            <td><strong>{row.total}</strong></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PlacedTable;